var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.containerStyles),on:{"click":_vm.handleScroll}},[_vm._t("default",function(){return [_c('Hyperlink',{attrs:{"text":_vm.label,"small":"","clickHandler":_vm.handleScroll}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }